core.directive('peselValidator', [
        function() {
            var definition = {
                require: 'ngModel',
                scope: {
                    identifierType: '=',
                    birthDate: '=',
                    gender: '=',
                    peselRequired: '='
                },
                link: function(scope, elm, attrs, ctrl) {
                    if(!attrs.peselRequired) {
                        scope.peselRequired = true;
                    }

                    scope.$watch('identifierType', function () {
                        ctrl.$validate();
                    });

                    ctrl.$validators.peselValidator = function(modelValue, viewValue) {

                        if(scope.identifierType === Enum.IDENTIFIER_TYPE.OTHER || (scope.identifierType === Enum.IDENTIFIER_TYPE.OTHER && modelValue.length < 11)) {
                            return true;
                        }
                        if(!modelValue && !scope.peselRequired) {
                            return true;
                        }
                        if(!modelValue || modelValue.length < 11) {
                            return false;
                        }
                        var regex = /^[0-9]{11}$/;
                        if(regex.test(modelValue) == false) {
                            return false;
                        } else {

                            var weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                            var sum = 0;
                            for(var i = 0; i < 10; i++){
                                sum += modelValue[i] * weights[i];
                            }
                            sum = sum % 10;
                            if(sum === 0) {
                                sum = 0;
                            } else {
                                sum = 10 - sum;
                            }
                            var valid = parseInt(modelValue[10]) === sum;
                            if(valid && scope.identifierType === Enum.IDENTIFIER_TYPE.PESEL) {
                                var aInt = [];
                                for(var i = 0; i < modelValue.length; i++) {
                                    aInt.push(parseInt(modelValue[i]));
                                }
                                var year = 1900+aInt[0]*10+aInt[1];
                                if (aInt[2]>=2 && aInt[2]<8)
                                    year+=Math.floor(aInt[2]/2)*100;
                                if (aInt[2]>=8)
                                    year-=100;

                                var month = (aInt[2]%2)*10+aInt[3];
                                var day = aInt[4]*10+aInt[5];
                                scope.birthDate = new Date(year, month-1, day);

                                if((aInt[9]%2==1)) {
                                    scope.gender = Enum.GENDER.MALE;
                                } else {
                                    scope.gender = Enum.GENDER.FEMALE;
                                }
                            }
                            return valid;
                        }
                    }
                }
            };

            return definition;
        }]
);